(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.getElementById('shopify-section-{{ section.id }}');
    const video = section && section.querySelector('.accio-hero__video');
    if (!video) return;

    const start = () => {
      const played = video.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
    };

    // Defer the first byte of video until the poster has painted, so the LCP
    // element stays the image instead of competing with the video download.
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 2500 });
    } else {
      window.setTimeout(start, 1500);
    }

    // If a browser blocks autoplay, start on the first interaction instead.
    window.addEventListener('pointerdown', start, { once: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
